function escapeMarkdownCell(value) {
  return String(value ?? '').replace(/\|/g, '\\|');
}

function getReportRows(report) {
  if (!report?.data) {
    return [];
  }

  return Array.isArray(report.data) ? report.data : report.data.results || [];
}

export function resolveRowsForCopy(selectedRows, report) {
  const rowKey = report?.row_key || 'id';
  const snapshot = selectedRows.map((row) => ({ ...row }));

  if (!snapshot.length) {
    return snapshot;
  }

  const allRows = getReportRows(report);
  if (!allRows.length) {
    return snapshot;
  }

  const selectedKeys = snapshot.map((row) => row[rowKey]);
  const resolved = allRows.filter((row) => selectedKeys.includes(row[rowKey]));

  return resolved.length ? resolved.map((row) => ({ ...row })) : snapshot;
}

export function rowsToMarkdownTable(rows, fields = {}) {
  const columns = Object.entries(fields).filter(
    ([, field]) => field.is !== 'hidden'
  );

  if (!columns.length) {
    return '';
  }

  const headerRow =
    '| ' + columns.map(([, field]) => field.title).join(' | ') + ' |';
  const separator = '| ' + columns.map(() => '---').join(' | ') + ' |';
  const bodyRows = rows.map((row) => {
    const cells = columns.map(([key]) => escapeMarkdownCell(row[key]));
    return '| ' + cells.join(' | ') + ' |';
  });

  return [headerRow, separator, ...bodyRows].join('\n');
}

async function copyMarkdown({ selectedRows, report }) {
  const rows = resolveRowsForCopy(selectedRows, report);
  const markdown = rowsToMarkdownTable(rows, report?.fields || {});

  if (!markdown) {
    throw new Error('No rows available to copy');
  }

  await navigator.clipboard.writeText(markdown);
}

export const reportActionHandlers = {
  copyMarkdown,
};

export async function runReportActionHandler(handler, context) {
  const fn = reportActionHandlers[handler];

  if (!fn) {
    throw new Error(`Unknown report action handler: ${handler}`);
  }

  return fn(context);
}
